import IndexedDB from ".";
import dbConfig from "./config";
var ErrorDb = new IndexedDB(dbConfig, "errors");
ErrorDb.initialize();
export { ErrorDb };
